import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhLabelComponent } from './components/fh-label.component';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';
import { FhLabelConfigPipe } from './helpers/pipe/fh-label-config.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { FhPipesModule } from '@fh-client-interaction-frontends/fh-pipes';

@NgModule({
  imports: [CommonModule, TranslateModule, SkeletonModule, TooltipModule, FhPipesModule],
  declarations: [FhLabelComponent, FhLabelConfigPipe],
  exports: [FhLabelComponent, FhLabelConfigPipe]
})
export class FhLabelModule {}
